module.exports = __webpack_public_path__ + "img/sketch-bettype-mobile.48782498.svg";